<template>
  <ValidationProvider
    ref="input"
    :rules="rules"
    :vid="vid"
    :name="label"
    v-slot="{ errors }"
  >
    <div 
    :class="cssTheme" 
    class="k-input-group">
      <label :for="id" class="k-label">{{ label }}</label>
      <div class="k-input-field">
        <input
          :id="id"
          class="k-input"
          :class="cssTheme"
          :type="fieldType"
          v-bind:value="value"
          @keyup.enter="$emit('enter')"
          @input="$emit('input', $event.target.value)"
          :autocomplete="autocomplete"
          :placeholder="placeholder"
          @focus="$event.target.select()"
          :disabled="readonly == true"
        />
        <!-- :style="themeStyle" -->
        <font-awesome-icon
          v-if="type === 'password'"
          @click="hidePassword = !hidePassword"
          class="text-primary mid-grey mx-2 k-input-icon pointer"
          :icon="icon"
        />
      </div>
      <span v-if="errors[0]" 
      class="mt-0 text-danger text-size-12 validation-errors">{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'InputTextFieldValidated',
  components: {
    ValidationProvider,
  },
  props: [
    'value',
    'label',
    'id',
    'rules',
    'vid',
    'type',
    'inputClass',
    'autocomplete',
    'darkMode',
    'placeholder',
    'readonly'
  ],

  data() {
    return {
      hidePassword: true,
    }
  },

  methods: {
    validate() {
      const provider = this.$refs['input'];
      // Validate the field
      return provider.validate();        
    }
  },

  computed: {
    cssTheme() {
      if (this.darkMode) return 'text-dark-mode';
      return 'text-light_mode';
    },


    fieldType() {
      if( this.type != 'password') return this.type;
      if( this.hidePassword) return 'password'
      return 'text'
    },

    icon() {
      if( this.hidePassword) {
        return ['fal', 'eye-slash'];
      }
      return ['fal', 'eye'];      
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/colors.scss';

.k-input-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.k-input-field {
  display: flex;
  flex-direction: row;
}

input.k-input {
  border: none;
  width: 100%;
  padding: 0px 0px 0px;
  display: inline-block;
  font-size: 16px;
  background: transparent;
  border-radius: 0px;
  border-bottom: 1px solid $light-grey;
}

input.k-input:focus {
  border: none;
  outline: none;
  border-radius: 0px;
  border-bottom: 2px solid $primary;
}

.k-input-icon {
  font-size: 22px;

}

.k-label {
  font-size: 12px;
  // padding-left: 5px;
  display: block;
}

label.k-label {
  margin-bottom: 0;
}

.light > {
  .k-label {
    color: $mid-grey;
  }

  .k-input {
    color: $dark-grey;
  }
}

.dark > {
  .k-label {
    color: white;
  }

  .k-input {
    color: white;
  }
}

.validation-errors {
  display: block;
  margin-top: 5px;
}

input + .validation-errors {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.8rem;
  color: #dc3545;
}

.text-primary.mid-grey {
  color: $mid-grey !important;
}
</style>
